




import Vue from 'vue'
import Component from 'vue-class-component'
import ResidentAutoPayments from '../components/ResidentAutoPayments.vue'

@Component({
  components: { ResidentAutoPayments }
})
export default class ResidentAutoPaymentTab extends Vue {
  get residentId () {
    return this.$route.params.id
  }
}
